import { ButtonSecondary, InputMessage, SegmentedControl, typographyRem } from '@by-miles/bymiles-styles'

import { AddressInput } from '../../../../../../generated/graphql'
import { formatPostcode } from '../../../../../../utils/formatPostcode'
import { FindMyAddress } from '../../../../../FindMyAddress'
import { ToolTip } from '../../../../../ToolTip'
const { h5: H5, paragraphBody: ParagraphBody, labelSmall: LabelSmall } = typographyRem

interface AddressProps {
  showErrorBanner: boolean
  notAnsweredMessage: string
  parkedAtHome?: boolean | null
  handleParkedAtHome: (value: boolean) => void
  customAddressPostcode: string
  handleCustomAddress: (value?: string | null) => void
  postcodeValid: boolean
}

export const Address = ({
  showErrorBanner,
  notAnsweredMessage,
  parkedAtHome,
  handleParkedAtHome,
  customAddressPostcode,
  handleCustomAddress,
  postcodeValid,
}: AddressProps) => {
  return (
    <>
      <div className="question-container" id="parkedAtHome">
        <div className="question-text-container">
          <H5>Do you keep your car at home overnight?</H5>
          <ParagraphBody className="question-info">
            This can be within a quarter mile of your home address.
          </ParagraphBody>
        </div>
        <div className="input-info-container">
          <SegmentedControl
            options={[
              { label: 'yes', value: true },
              { label: 'no', value: false },
            ]}
            name="is-parked-home"
            onClick={value => typeof value === 'boolean' && handleParkedAtHome(value)}
            dataCy="is-parked-home-toggle"
            className="info-item"
            preFilledValue={parkedAtHome}
            error={showErrorBanner && parkedAtHome === null ? notAnsweredMessage : undefined}
            ariaLiveOnFocus
          />
          <ToolTip
            text="Answer 'yes' if you mostly park your car in your garage, on your drive, on the street outside your house or in a nearby car park. Answer 'no' if you normally keep it somewhere else away from home."
            className="tool-tip tip-top-medium"
            dataCy="is-parked-home-info-button"
          />
        </div>
      </div>

      {parkedAtHome === false && (
        <div className="question-container">
          <div className="question-text-container">
            <H5>Where is your car normally parked overnight?</H5>
          </div>
          {!customAddressPostcode && (
            <FindMyAddress
              dataCy="parked-location"
              setAddress={(value: AddressInput) => handleCustomAddress(value?.postcode || '')}
              showConfirmButtons={false}
              showCantFindAddressLink={false}
              toopTip="If you don't normally park your car near your house overnight, we need a little more information about where you keep it so we can work out how safe it is from theft or damage."
            />
          )}
          {customAddressPostcode && (
            <>
              <div className="address-text-container">
                <LabelSmall>{`${'postcode'}`.toUpperCase()}</LabelSmall>
                <H5>{formatPostcode(customAddressPostcode)}</H5>
              </div>
              <ButtonSecondary
                className="edit LoNotSensitive"
                label="Edit"
                icon
                onClick={handleCustomAddress}
                dataCy="edit-address-button"
              />
            </>
          )}
          {showErrorBanner && !postcodeValid && (
            <InputMessage
              position="bottom"
              message="Please enter your postcode and select your address from the list to continue."
              hideArrow
              className="page-level-error"
            />
          )}
        </div>
      )}
    </>
  )
}
